import { render } from "./PreviewElementWrapper.vue?vue&type=template&id=6b68f97e&scoped=true"
import script from "./PreviewElementWrapper.vue?vue&type=script&lang=js"
export * from "./PreviewElementWrapper.vue?vue&type=script&lang=js"

import "./PreviewElementWrapper.vue?vue&type=style&index=0&id=6b68f97e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b68f97e"]])

export default __exports__